import makeCrudModule from '@/lib/uncrudtable/store/crudfactory'
import apiClient from '@/lib/unlogin/store/apiclient'
import { makeGenericCalendarStore } from '@/apps/core/store/genericCalendarStore'

const modelName = 'ProductsCalendar'
const apiPath = '/campaign-template-products-calendar/'
const baseCrud = makeCrudModule(apiClient, modelName, apiPath)
const genericCalendarStore = makeGenericCalendarStore(apiClient, apiPath)

const state = {
  ...baseCrud.state,
  ...genericCalendarStore.state
}

const getters = {
  ...baseCrud.getters
}

const actions = {
  ...baseCrud.actions,
  ...genericCalendarStore.actions
}

const mutations = {
  ...baseCrud.mutations,
  ...genericCalendarStore.mutations
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
